import { cDatabaseApi, cDbQuery, DbCompare, DbOperator } from "./DatabaseApi";

export interface PropertyTab {
  sectionName: string;
  location: string;
  property: string;
  display: string;
}

export interface SearchProperty {
  property: string;
  display: string;
  width: number;
}

export class cPropertiesApi {
  private static propertyViewTabs: PropertyTab[] = [];
//  private static propertyTabData: Map<string, string>;
  private static propertyTabData: Map<string, Map<string,string>>;
  private static searchTab: SearchProperty[] = [];
  private static searchData: Map<string, string>[] = [];
  private static sd = Map<string, Map<string,string>>;

  public static async initProperties(model: string) {
      await this.initPropertyTab();
      await this.initSearchTab();
  }

  private static async initPropertyTab() {
    const q = new cDbQuery("PropertyTab");
    const dbRows = await cDatabaseApi.query(q);
    while (dbRows.next()) {
      const viewTabs : PropertyTab = {
        "sectionName": dbRows.getProperty("SectionName"),
        "location": dbRows.getProperty("Location"),
        "property": dbRows.getProperty("Property"),
        "display": dbRows.getProperty("Display")
      };
      this.propertyViewTabs.push(viewTabs);
    }
  }

  private static async initSearchTab() {
    this.searchTab.push({"property": "Tag", 
                        "display": "Tag", 
                        "width": 100}
                        );  // first property is always Tag

    const q = new cDbQuery("SearchTab");
    const dbRows = await cDatabaseApi.query(q);
    while (dbRows.next()) {
      const searchProps : SearchProperty = {
        "property": dbRows.getProperty("Property"),
        "display": dbRows.getProperty("Display"),
        "width": Number(dbRows.getProperty("Width"))
      };
      this.searchTab.push(searchProps);
    }
  }

  public static loadPropertyTabData = async (tag: string) => {

    if (tag) {
      this.propertyTabData = new Map();

      for (const section of this.getSectionList()) {

        const q = new cDbQuery(this.getSectionLocation(section));
        q.setWhere("Tag", tag);

        const dbRows = await cDatabaseApi.query(q);
        while (dbRows.next()) {
          const data : Map<string,string> = dbRows.getKeyValues();
          this.propertyTabData.set(section, data);
          // data.forEach((pValue : string, pLabel : string) => {
          //   this.propertyTabData.set(pLabel, pValue);
          // });
        }
      }
    }
  }

  public static getSectionList = () : string[] => {
    const sectionList : string[] = [];

    for (const section of this.propertyViewTabs) {
      if (!sectionList.includes(section.sectionName)) {
        sectionList.push(section.sectionName);
      }
    }

    return sectionList;
  }

  public static getSectionLocation = (sectionName : string) : string => {

    for (const section of this.propertyViewTabs) {
      if (section.sectionName == sectionName) {
        return(section.location);
      }
    }

    return "";
  }

  public static getSectionProperties = (sectionName : string) : Map<string, string> => {
//    const props: Map<string, string> = new Map();

    // for (const section of this.propertyViewTabs) {
    //   if (section.sectionName == sectionName) {
    //     props.set(section.property, section.display);
    //   }
    // }

    const props = this.propertyTabData.get(sectionName)!;

    return props;
  }

  // public static getPropertyValue = (propName : string) : string => {
  //   return this.propertyTabData.get(propName)!;
  // }

  public static getPropertyDisplay = (sectionName: string, propName : string) : string => {
    let display : string = "";

    for (const section of this.propertyViewTabs) {
      if (section.sectionName == sectionName && section.property == propName) {
        display = section.display;
      }
    }

    return display;
  }


  public static getPropertyViewTabs = () => {
    return this.propertyViewTabs;
  }

  // public static setPropertyData = (propertyData : Map<string,string>) => {
  //   this.propertyTabData = propertyData;
  // }

  public static getPropertyData = () => {
    return this.propertyTabData;
  }

  public static emptyPropertyData = () => {
    if (this.propertyTabData) {
      this.propertyTabData.clear();
    }
  }

  public static loadSearchData = async (keyword: string) => {
    const data : Map<string, string>[] = [];
    this.searchData = [];

    const q = new cDbQuery("Properties");

    if (keyword && keyword != "*") {
      for (const prop of this.searchTab) {
        q.setWhere(prop.property, keyword, DbCompare.Like);
      }
      q.setOperator(DbOperator.Or);
    }

    const dbRows = await cDatabaseApi.query(q);
    while (dbRows.next()) {
      const dataRow = dbRows.getKeyValues();
      this.searchData.push(dataRow);
    }

  }

  public static getSearchProperties = () : SearchProperty[] => {
    return this.searchTab;
  }

  public static getSearchData = () : Map<string, string>[] => {
    return this.searchData;
  }
}
